import { useEffect, useState } from 'react';
import { get, getDatabase, ref } from 'firebase/database';

export async function loadLegacyContactNote(evalId) {
  // Read only the original clinician note, not the large raw gaze record.
  const snapshot = await get(ref(getDatabase(), `evals/${evalId}/contact_note`));
  const value = snapshot.val();
  if (value == null) return '';
  if (typeof value !== 'string') throw new Error('Invalid contact note');
  return value;
}

export default function LegacyContactNotes({ evalId, loadNote = loadLegacyContactNote }) {
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({ evalId: null, status: 'loading', note: '' });

  useEffect(() => {
    let active = true;
    setState({ evalId, status: 'loading', note: '' });
    if (!evalId) {
      setState({ evalId, status: 'error', note: '' });
      return () => { active = false; };
    }
    Promise.resolve().then(() => loadNote(evalId)).then(
      (note) => { if (active) setState({ evalId, status: 'ready', note }); },
      () => { if (active) setState({ evalId, status: 'error', note: '' }); },
    );
    return () => { active = false; };
  }, [evalId, loadNote, attempt]);

  const status = state.evalId === evalId ? state.status : 'loading';
  return (
    <section aria-labelledby="contact-notes-heading" className="max-w-3xl rounded-md border border-gray-200 bg-white p-6">
      <h2 id="contact-notes-heading" className="text-base font-semibold text-gray-900">Contact notes</h2>
      <p className="mt-1 text-sm text-gray-500">Recorded by the clinician when this evaluation was submitted.</p>
      {status === 'loading' && <p className="mt-4 text-sm text-gray-600" role="status">Loading contact notes…</p>}
      {status === 'error' && (
        <div className="mt-4">
          <p role="alert" className="text-sm text-red-700">Contact notes could not be loaded.</p>
          <button type="button" className="mt-3 rounded-md border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-600" onClick={() => setAttempt((value) => value + 1)}>Retry</button>
        </div>
      )}
      {status === 'ready' && (state.note.trim() ? (
        <p className="mt-4 whitespace-pre-wrap break-words text-sm leading-6 text-gray-900">{state.note}</p>
      ) : <p className="mt-4 text-sm text-gray-500">No contact notes were recorded for this evaluation.</p>)}
    </section>
  );
}
